






































































































































































import mixins from 'vue-typed-mixins';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { OperationsMixin } from '@/main/mixins/operations';
import { getStavZakazka } from '@/modules/servis/zakazka/utils';

import { ZAKAZKA_STAV } from '../../constants';
import { SkupinaProfilSelect } from '../../components';
import JinyPrijemceSelect from '../../components/microcomponents/JinyPrijemceSelect.vue';
import LeasingSelect from '../../components/microcomponents/LeasingSelect.vue';
import ZakazkaCheckInSelect from '../../components/microcomponents/CheckInSelect.vue';
import PojistovnaSelect from '../../components/microcomponents/PojistovnaSelect.vue';
import ProvozovnaSelect from '../../components/microcomponents/ProvozovnaSelect.vue';
import SlevaMaterialNumberInput from '../../components/microcomponents/SlevaMaterialNumberInput.vue';
import SmluvniPartnerSelect from '../../components/microcomponents/SmluvniPartnerSelect.vue';
import SmluvniPartnerTypSelect from '../../components/microcomponents/SmluvniPartnerTypSelect.vue';
import { store } from '../../store/edit';
import SDA from '../../components/microcomponents/SDA.vue';
import CisloSchvaleniInput from '../../components/microcomponents/CisloSchvaleniInput.vue';
import MicroLakDruhSelect from '../../components/microcomponents/LakDruhSelect.vue';
import SlevaInputNumber from '../../components/microcomponents/SlevaInputNumer.vue';
import { EditMixin } from '../../mixins/editMixin';

export default mixins(PageModeMixin, EditMixin, OperationsMixin).extend({
	name: 'HlavniKarta',
	data() {
		return {
			FeedbackMarks: {
				0: this.Localize('POOR'),
				1: '',
				2: '',
				3: '',
				4: '',
				5: this.Localize('AVERAGE_FB'),
				6: '',
				7: '',
				8: '',
				9: '',
				10: this.Localize('EXCELLENT'),
			},
		};
	},
	components: {
		MicroLakDruhSelect,
		CisloSchvaleniInput,
		SmluvniPartnerTypSelect,
		SlevaMaterialNumberInput,
		ProvozovnaSelect,
		PojistovnaSelect,
		SkupinaProfilSelect,
		LeasingSelect,
		SmluvniPartnerSelect,
		JinyPrijemceSelect,
		SlevaInputNumber,
		ZakazkaCheckInSelect,
		sda: SDA,
	},
	computed: {
		...genVuexComputeds(store),
		ddCustomerRevisitPrp() : boolean | null {
			return this.dmsSys.CustomerRevisitPrp && this.IsCustRevisit;
		},
		prevodMaxSuffix() {
			return ` (${this.PrevodMaxLimit ? this.PrevodMaxLimit : 0})`;
		},
		isCreateOrEditMode(): boolean {
			return this.isEditMode;
		},
		isCommunicationModeVisible(): boolean | null {
			return this.dmsSys.IsCommMode_IsDocConf_Prp && ![ZAKAZKA_STAV.V_PRIPRAVE, ZAKAZKA_STAV.NABIDKA].includes(getStavZakazka(this.edit));
		},
	},
});
